import { connect } from 'react-redux'
import CreateTrip from '../../components/trips/CreateTrip'
import * as actions from '../../state/actions/trips'
import * as riderReducers from '../../state/reducers/riders'
import * as organizationReducers from '../../state/reducers/organizations'
import { IStoreState, IRiderSearchObject, ITripPassengerDetail } from '../../types'
import { mapViewStrategyStages } from '../../components/MapView'
import { actionCreators as mapsActionCreators } from '../../state/actions/google_map'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  const riderId = ownProps.match.params.riderId
  const rider = riderReducers.getRiderById(state.riders, riderId)
  const tripRequest = state.tripRequest || { request: {} }
  const request = tripRequest.request
  const orgId = organizationReducers.getCurrentOrganizationId(state)
  const tripInfo = {
    origin: {
      address: request.pickupLocation.fullAddress,
      lat: request.pickupLocation.coordinates
        ? request.pickupLocation.coordinates.coordinates[1]
        : request.pickupLocation.latitude,
      lng: request.pickupLocation.coordinates
        ? request.pickupLocation.coordinates.coordinates[0]
        : request.pickupLocation.longitude,
      placeName: request.pickupLocation.placeName,
      notes: request.pickupLocation.notes
    },
    destination: {
      address: request.dropoffLocation.fullAddress,
      lat: request.dropoffLocation.coordinates
        ? request.dropoffLocation.coordinates.coordinates[1]
        : request.dropoffLocation.latitude,
      lng: request.dropoffLocation.coordinates
        ? request.dropoffLocation.coordinates.coordinates[0]
        : request.dropoffLocation.longitude,
      placeName: request.dropoffLocation.placeName,
      phoneNumber: request.dropoffLocation.phoneNumber,
      notes: request.dropoffLocation.notes
    },
    orgId,
    notes: request.notes,
    scheduledPickupTime: request.scheduledPickupTime,
    leaveAtDateTime: request.leaveAtDateTime,
    arriveByDateTime: request.arriveByDateTime,
    scheduledDropoffTime: request.scheduledDropoffTime,
    recurringPickupTime: request.recurringPickupTime,
    recurringDropoffTime: request.recurringDropoffTime,
    additionalRiders: request.additionalRiders,
    serviceId: state.trips.filters.serviceId,
    willCall: request.willCall,
    confirmationNumber: request.confirmationNumber,
    providerOneNumber: request.providerOneNumber,
    tripRequester: request.tripRequester,
    additionalStop: request.additionalStop.map(loc => ({
      address: loc.fullAddress,
      lat: loc.coordinates ? loc.coordinates.latitude : loc.latitude,
      lng: loc.coordinates ? loc.coordinates.longitude : loc.longitude,
      placeName: loc.placeName,
      notes: loc.notes
    })),
    scheduledReturn: request.scheduledReturn,
    returnPickupTime: request.returnPickupTime
  }
  return {
    riderId,
    rider,
    orgId,
    organization: organizationReducers.getCurrentOrganization(state),
    tripRequest: state.tripRequest,
    tripInfo,
    polyline: state.mapView.polyline,
    additionalRiders: request.additionalRiders
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    fetchUserTrips: (userId: string) => dispatch(actions.userTripsFetch(userId)),
    selectRider: (rider: IRiderSearchObject) => dispatch(actions.selectRider(rider)),
    selectOrg: (orgId: string) => dispatch(actions.actionCreators.selectOrg(orgId)),
    setCurrentTripStage: () =>
      dispatch(mapsActionCreators.setMapViewStrategyStage(mapViewStrategyStages.showNearbyDrivers)),
    getAvailableProducts: (riderId: string, tripInfo: any) => {
      return dispatch(actions.tripAvailableProducts(riderId, tripInfo))
    },
    updateTripNotes: (notes: string) => dispatch(actions.actionCreators.updateTripNotes(notes)),
    updateTripConfirmationNumber: (confirmationNumber: string) =>
      dispatch(actions.actionCreators.updateTripConfirmationNumber(confirmationNumber)),
    updateTripProviderOneNumber: (providerOneNumber: string) =>
      dispatch(actions.actionCreators.updateTripProviderOneNumber(providerOneNumber)),
    updateRiderCount: (count: number) => dispatch(actions.actionCreators.updateRiderCount(count)),
    setTripPassengerDetails: (passengerDetails: ITripPassengerDetail) =>
      dispatch(actions.actionCreators.setTripPassengerDetails(passengerDetails)),
    updateTripRequester: (requesterName: string) => dispatch(actions.actionCreators.updateTripRequester(requesterName)),
    setScheduledTime: (time: string, type: string) => {
      if (type === 'pickup') {
        return Promise.all([
          dispatch(actions.actionCreators.setDropoffToTripRequest()),
          dispatch(actions.actionCreators.setPickupToTripRequest(time)),
          dispatch(actions.actionCreators.setLeaveAtToTripRequest()),
          dispatch(actions.actionCreators.setArriveByToTripRequest()),
          dispatch(actions.actionCreators.setRecurringDropoffTime()),
          dispatch(actions.actionCreators.setRecurringPickupTime())
        ])
      } else if (type === 'dropoff') {
        return Promise.all([
          dispatch(actions.actionCreators.setDropoffToTripRequest(time)),
          dispatch(actions.actionCreators.setPickupToTripRequest()),
          dispatch(actions.actionCreators.setLeaveAtToTripRequest()),
          dispatch(actions.actionCreators.setArriveByToTripRequest()),
          dispatch(actions.actionCreators.setRecurringDropoffTime()),
          dispatch(actions.actionCreators.setRecurringPickupTime())
        ])
      } else if (type === 'leave-at') {
        return Promise.all([
          dispatch(actions.actionCreators.setDropoffToTripRequest()),
          dispatch(actions.actionCreators.setPickupToTripRequest()),
          dispatch(actions.actionCreators.setLeaveAtToTripRequest(time)),
          dispatch(actions.actionCreators.setArriveByToTripRequest()),
          dispatch(actions.actionCreators.setRecurringDropoffTime()),
          dispatch(actions.actionCreators.setRecurringPickupTime())
        ])
      } else if (type === 'arrive-by') {
        return Promise.all([
          dispatch(actions.actionCreators.setDropoffToTripRequest()),
          dispatch(actions.actionCreators.setPickupToTripRequest()),
          dispatch(actions.actionCreators.setLeaveAtToTripRequest()),
          dispatch(actions.actionCreators.setArriveByToTripRequest(time)),
          dispatch(actions.actionCreators.setRecurringDropoffTime()),
          dispatch(actions.actionCreators.setRecurringPickupTime())
        ])
      } else if (type === 'recurPickup') {
        return Promise.all([
          dispatch(actions.actionCreators.setDropoffToTripRequest()),
          dispatch(actions.actionCreators.setPickupToTripRequest()),
          dispatch(actions.actionCreators.setLeaveAtToTripRequest()),
          dispatch(actions.actionCreators.setArriveByToTripRequest()),
          dispatch(actions.actionCreators.setRecurringDropoffTime()),
          dispatch(actions.actionCreators.setRecurringPickupTime(time))
        ])
      } else if (type === 'recurDropoff') {
        return Promise.all([
          dispatch(actions.actionCreators.setDropoffToTripRequest()),
          dispatch(actions.actionCreators.setPickupToTripRequest()),
          dispatch(actions.actionCreators.setLeaveAtToTripRequest()),
          dispatch(actions.actionCreators.setArriveByToTripRequest()),
          dispatch(actions.actionCreators.setRecurringDropoffTime(time)),
          dispatch(actions.actionCreators.setRecurringPickupTime())
        ])
      } else {
        return Promise.all([
          dispatch(actions.actionCreators.setDropoffToTripRequest()),
          dispatch(actions.actionCreators.setPickupToTripRequest()),
          dispatch(actions.actionCreators.setLeaveAtToTripRequest()),
          dispatch(actions.actionCreators.setArriveByToTripRequest()),
          dispatch(actions.actionCreators.setRecurringDropoffTime()),
          dispatch(actions.actionCreators.setRecurringPickupTime())
        ])
      }
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateTrip)



// WEBPACK FOOTER //
// ./src/containers/trips/CreateTrip.ts